import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosConfig.jsx';
import PageHeaderTile from '../ui/PageHeaderTile';
import { ClipboardList } from 'lucide-react';
import HistoryLogList from '../history-log/HistoryLogList.js';

function HistoryPage() {
    const [logs, setLogs] = useState([]);
    const [page, setPage] = useState(0);
    const [size] = useState(20);
    const [hasMore, setHasMore] = useState(true);

    const fetchLogs = (page, size) => {
        axiosInstance.get(`/api/audit-logs?page=${page}&size=${size}`)
            .then(response => response.data)
            .then(data => {
                if (data.length < size) {
                    setHasMore(false);
                }
                setLogs(prevLogs => [...prevLogs, ...data]);
            })
            .catch(error => console.error('Error fetching logs:', error));
    };

    const loadMore = () => {
        setPage(prevPage => prevPage + 1);
    };

    useEffect(() => {
        fetchLogs(page, size);
    }, [page, size]);

    return (
        <div className="w-full max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 flex flex-col gap-8">
            <PageHeaderTile title="История на действията" icon={ClipboardList} />
            
            <HistoryLogList
                logs={logs}
                loadMore={loadMore}
                hasMore={hasMore}
            />
        </div>
    );
}

export default HistoryPage;
